import { Option } from "api/types/_public";
import imgEmail from "../assets/images/platform/mail.webp";
import imgGoogle from "../assets/images/platform/google.svg";
import imgKakao from "../assets/images/platform/kakao.svg";
import imgNaver from "../assets/images/platform/naver.svg";
import imgApple from "../assets/images/platform/apple.svg";
import imgAmazon from "../assets/images/platform/amazon.svg";
import imgFirebase from "../assets/images/platform/firebase.svg";
import imgFacebook from "../assets/images/platform/facebook.svg";
import imgTiktok from "../assets/images/platform/tiktok.svg";
import imgOffline from "../assets/images/platform/offline.png";
import imgInstagram from "../assets/images/platform/instagram.png";
import imgYoutube from "../assets/images/platform/youtube.png";
import imgUSD from "../assets/images/currency/usd.png";
import imgKRW from "../assets/images/currency/won.png";
import imgBaive from "../assets/images/appname/baive.png";
import imgBaiveManager from "../assets/images/appname/baive-manager.png";
import noImage from "../assets/images/no-image.jpg";
import picaverseImage from "../assets/images/channel/picaverse_app.png";
import starplusImage from "../assets/images/channel/starplus_web.png";

export const SCHEDULE_OPTIONS: Option[] = [
  {
    label: "Now",
    value: "now",
  },
  {
    label: "Daily",
    value: "daily",
  },
  {
    label: "Weekly",
    value: "weekly",
  },
  {
    label: "Monthly",
    value: "monthly",
  },
  // {
  //   label: 'Except Holiday In Korea',
  //   value: 'except_holiday_in_Korea',
  // }
];

export const SCHEDULE_MONTHLY_OPTIONS: Option[] = Array.from(
  { length: 31 },
  (_, index) => {
    const day = (index + 1).toString().padStart(2, "0");
    return { label: `${day}th`, value: day };
  }
);

export const SCHEDULE_WEEKLY_OPTIONS: Option[] = [
  {
    label: "Monday",
    value: "1",
  },
  {
    label: "Tuesday",
    value: "2",
  },
  {
    label: "Wednesday",
    value: "3",
  },
  {
    label: "Thursday",
    value: "4",
  },
  {
    label: "Friday",
    value: "5",
  },
  {
    label: "Saturday",
    value: "6",
  },
  {
    label: "Sunday",
    value: "7",
  },
];

export const SCHEDULE_CAMPAIGN_STATISTIC_OPTIONS: Option[] = [
  {
    label: "Daily",
    value: "daily",
  },
  {
    label: "Weekly",
    value: "weekly",
  },
  {
    label: "Monthly",
    value: "monthly",
  },
];

export const ACTION_TYPE_CAMPAIGN = {
  SAVE: "save",
  POST: "post",
};

export const METHOD_OPTIONS: Option[] = [
  {
    label: "GET",
    value: "GET",
  },
  {
    label: "POST",
    value: "POST",
  },
  {
    label: "PUT",
    value: "PUT",
  },
  {
    label: "DELETE",
    value: "DELETE",
  },
];

export const IS_OPTIONS: Option[] = [
  {
    label: "YES",
    value: "1",
  },
  {
    label: "NO",
    value: "0",
  },
];

export const TYPE_SHOW_MORE_HASHTAG = {
  SCROLL: "scroll",
  MODAL: "modal",
};

export const ARR_INDEX_TEXT_DAY_OF_WEEK: string[] = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

//dispatch

export const TYPE_POST: Option[] = [
  {
    label: "Feed",
    value: "feed",
  },
  {
    label: "Card",
    value: "card",
  },
];

// Status
export const ENUM_STATUS_ACTIVE_DISABLE = {
  ACTIVATE: 1,
  DISABLED: 2,
};

export const COLOR_STATUS_ACTIVE_DISABLE: any = {
  [ENUM_STATUS_ACTIVE_DISABLE.ACTIVATE]: "success",
  [ENUM_STATUS_ACTIVE_DISABLE.DISABLED]: "danger",
};

export const STATUS_ACTIVE_DISABLE_OPTION = [
  {
    label: "Active",
    value: ENUM_STATUS_ACTIVE_DISABLE.ACTIVATE,
  },
  {
    label: "Disable",
    value: ENUM_STATUS_ACTIVE_DISABLE.DISABLED,
  },
];

// Artist
export const ENUM_TYPE_ARTIST = {
  DEFAULT: "default",
  IDOL: "idol",
  ACTOR: "actor",
  ENTERTAINMENT: "entertainment",
};

export const COLOR_TYPE_ARTIST: any = {
  [ENUM_TYPE_ARTIST.DEFAULT]: "warning",
  [ENUM_TYPE_ARTIST.IDOL]: "primary",
  [ENUM_TYPE_ARTIST.ACTOR]: "success",
  [ENUM_TYPE_ARTIST.ENTERTAINMENT]: "danger",
};

export const COLOR_TYPE_ARTIST_TDI: any = {
  1: "warning",
  2: "primary",
  3: "success",
  4: "danger",
};

export const ENUM_STATUS_ARTIST = {
  ACTIVATED: "activated",
  DISABLED: "disabled",
};

export const COLOR_STATUS_ARTIST: any = {
  [ENUM_STATUS_ARTIST.ACTIVATED]: "success",
  [ENUM_STATUS_ARTIST.DISABLED]: "danger",
};

export const STATUS_ARTIST_OPTION = [
  {
    label: "Activated",
    value: ENUM_STATUS_ARTIST.ACTIVATED,
  },
  {
    label: "Disabled",
    value: ENUM_STATUS_ARTIST.DISABLED,
  },
];

// User
export const ENUM_STATUS_USER = {
  PENDING: "pending",
  ACTIVATED: "activated",
  DISABLED: "disabled",
};

export const COLOR_STATUS_USER: any = {
  [ENUM_STATUS_USER.PENDING]: "primary",
  [ENUM_STATUS_USER.ACTIVATED]: "success",
  [ENUM_STATUS_USER.DISABLED]: "danger",
};

export const STATUS_USER_OPTION = [
  {
    label: "Pending",
    value: ENUM_STATUS_USER.PENDING,
  },
  {
    label: "Activated",
    value: ENUM_STATUS_USER.ACTIVATED,
  },
  {
    label: "Disabled",
    value: ENUM_STATUS_USER.DISABLED,
  },
];

//Advertisement

export const ENUM_STATUS_ADVERTISEMENT = {
  ACTIVATED: "true",
  DISABLED: "false",
};

export const COLOR_STATUS_ADVERTISEMENT: any = {
  [ENUM_STATUS_ADVERTISEMENT.ACTIVATED]: "success",
  [ENUM_STATUS_ADVERTISEMENT.DISABLED]: "danger",
};

export const STATUS_ADVERTISEMENT_OPTION = [
  {
    label: "Activated",
    value: ENUM_STATUS_ADVERTISEMENT.ACTIVATED,
  },
  {
    label: "Disabled",
    value: ENUM_STATUS_ADVERTISEMENT.DISABLED,
  },
];

export const ENUM_POSITION_ADVERTISEMENT = {
  HOT: "hot",
  NEWS: "news",
  WALLPAPER_EDIT: "wallpaper_edit",
  VIDEO: "video",
  FEED: "feed",
};

export const COLOR_POSITION_ADVERTISEMENT: any = {
  [ENUM_POSITION_ADVERTISEMENT.HOT]: "warning",
  [ENUM_POSITION_ADVERTISEMENT.NEWS]: "primary",
  [ENUM_POSITION_ADVERTISEMENT.WALLPAPER_EDIT]: "info",
  [ENUM_POSITION_ADVERTISEMENT.VIDEO]: "danger",
  [ENUM_POSITION_ADVERTISEMENT.FEED]: "success",
};

export const COLOR_STATUS_USED: any = {
  used: "primary",
  unused: "success",
};

export const LIST_OPTION_PLATFORM = [
  {
    label: "Platform_Email",
    value: "default",
  },
  {
    label: "Platform_Kakao",
    value: "kakao",
  },
  {
    label: "Platform_Naver",
    value: "naver",
  },
  {
    label: "Platform_Google",
    value: "google",
  },
  {
    label: "Platform_Apple",
    value: "apple",
  },
  {
    label: "Platform_Apple_Firebase",
    value: "firebase",
  },
];

export const LIST_OPTION_OS = [
  {
    label: "iOS",
    value: "ios",
  },
  {
    label: "Android",
    value: "android",
  },
];

export const getPlatFormImage = (type: string) => {
  switch (type) {
    case "default":
      return imgEmail;
    case "google":
      return imgGoogle;
    case "naver":
      return imgNaver;
    case "kakao":
      return imgKakao;
    case "apple":
      return imgApple;
    case "amazon":
      return imgAmazon;
    case "firebase":
      return imgFirebase;
    case "facebook":
      return imgFacebook;
    case "tiktok":
      return imgTiktok;
    case "offline":
      return imgOffline;
    case "instagram":
      return imgInstagram;
    case "youtube":
      return imgYoutube;
    case "KRW":
      return imgKRW;
    case "USD":
      return imgUSD;
    default:
      return "";
  }
};

export const getChannelImage = (type: string) => {
  switch (type) {
    case "starplus_web":
      return starplusImage;
    case "picaverse_app":
      return picaverseImage;
    default:
      return "";
  }
};

export const getOptionImage = (type: string) => {
  switch (type) {
    case "baive":
      return imgBaive;
    case "baive_manager":
      return imgBaiveManager;
    default:
      return noImage;
  }
};

export const LIST_OPTION_ROLE = [
  {
    value: "normal",
    label: "Normal",
  },
  {
    value: "premium",
    label: "Premium",
  },
];

export const ENUM_TYPE_ADVERTISEMENT = {
  NATIVE: "native",
  VIDEO: "video",
};

export const COLOR_TYPE_ADVERTISEMENT: any = {
  [ENUM_TYPE_ADVERTISEMENT.NATIVE]: "primary",
  [ENUM_TYPE_ADVERTISEMENT.VIDEO]: "danger",
};

//notification setting
export const ENUM_NOTI_SETTING_STATUS = {
  ACTIVATED: "activated",
  DISABLED: "disabled",
};

export const NOTI_SETTING_STATUS_OPTION = [
  { label: "Activated", value: ENUM_NOTI_SETTING_STATUS.ACTIVATED },
  { label: "Disabled", value: ENUM_NOTI_SETTING_STATUS.DISABLED },
];

export const ENUM_NOTIFY_TYPE = {
  AUTO: "auto",
  MANUAL: "manual",
};

export const COLOR_NOTIFY_TYPE: any = {
  [ENUM_NOTIFY_TYPE.AUTO]: "primary",
  [ENUM_NOTIFY_TYPE.MANUAL]: "danger",
};

export const ENUM_PUSH_STATUS = {
  WAITING: "waiting",
  COMPLETED: "completed",
};

export const COLOR_PUSH_STATUS: any = {
  [ENUM_PUSH_STATUS.WAITING]: "primary",
  [ENUM_PUSH_STATUS.COMPLETED]: "success",
};

export const LIST_OPTION_PUSH_STATUS = [
  {
    value: ENUM_PUSH_STATUS.WAITING,
    label: "Waiting",
  },
  {
    value: ENUM_PUSH_STATUS.COMPLETED,
    label: "Completed",
  },
];

export const ENUM_BAR_LIST_PLAN = {
  LIST_PLAN: "List",
  BOOST_PLAN: "Boost",
};

export const COLOR_BAR_LIST_PLAN: any = {
  [ENUM_BAR_LIST_PLAN.LIST_PLAN]: "primary",
  [ENUM_BAR_LIST_PLAN.BOOST_PLAN]: "warning",
};

export const LIST_OPTION_BAR_LIST_PLAN = [
  {
    value: ENUM_BAR_LIST_PLAN.LIST_PLAN,
    label: "Plan_List",
  },
  {
    value: ENUM_BAR_LIST_PLAN.BOOST_PLAN,
    label: "Plan_Boost",
  },
];

export const ENUM_BAR_LIST_OPEN_STATUS = {
  OPEN: 1,
  CLOSED: 0,
};

export const COLOR_BAR_LIST_OPEN_STATUS: any = {
  [ENUM_BAR_LIST_OPEN_STATUS.OPEN]: "success",
  [ENUM_BAR_LIST_OPEN_STATUS.CLOSED]: "danger",
};

export const LIST_OPTION_BAR_LIST_OPEN_STATUS = [
  {
    label: "Open",
    value: ENUM_BAR_LIST_OPEN_STATUS.OPEN,
  },
  {
    label: "Closed",
    value: ENUM_BAR_LIST_OPEN_STATUS.CLOSED,
  },
];

export const LIST_OPTION_BAR_LIST_TYPE = [
  {
    label: "Lounge",
    value: "Lounge",
  },
  {
    label: "Theme Bar",
    value: "Theme Bar",
  },
  {
    label: "Traditional",
    value: "Traditional",
  },
  {
    label: "Skybar",
    value: "Skybar",
  },
];

export const LIST_OPTION_BAR_LIST_RATING = [1, 2, 3, 4, 5]?.map(
  (item: any) => ({
    value: item,
    label: item,
  })
);

export const ENUM_BAR_DETAIL_STAFF_POSITION = {
  NORMAL: 1,
  BARTENDER: 2,
  MANAGER: 3,
};

export const COLOR_BAR_DETAIL_STAFF_POSITION: any = {
  [ENUM_BAR_DETAIL_STAFF_POSITION.NORMAL]: "primary",
  [ENUM_BAR_DETAIL_STAFF_POSITION.BARTENDER]: "success",
  [ENUM_BAR_DETAIL_STAFF_POSITION.MANAGER]: "warning",
};

export const LIST_OPTION_BAR_DETAIL_STAFF_POSITION = [
  {
    value: ENUM_BAR_DETAIL_STAFF_POSITION.NORMAL,
    label: "NORMAL",
  },
  {
    value: ENUM_BAR_DETAIL_STAFF_POSITION.BARTENDER,
    label: "BARTENDER",
  },
  {
    value: ENUM_BAR_DETAIL_STAFF_POSITION.MANAGER,
    label: "MANAGER",
  },
];

export const LIST_OPTION_BAR_DETAIL_WORKING_TIME_DAYS = [
  {
    label: "Monday",
    value: "0",
  },
  {
    label: "Tuesday",
    value: "1",
  },
  {
    label: "Wednesday",
    value: "2",
  },
  {
    label: "Thursday",
    value: "3",
  },
  {
    label: "Friday",
    value: "4",
  },
  {
    label: "Saturday",
    value: "5",
  },
  {
    label: "Sunday",
    value: "6",
  },
];

export const LIST_OPTION_BAR_DETAIL_REVIEW_STAR_RATING = [0, 1, 2, 3, 4, 5];

export const ENUM_BAR_DETAIL_REVIEW_STATUS = {
  ACTIVE: 1,
  DISABLE: 0,
};

export const COLOR_BAR_DETAIL_REVIEW_STATUS: any = {
  [ENUM_BAR_DETAIL_REVIEW_STATUS.ACTIVE]: "primary",
  [ENUM_BAR_DETAIL_REVIEW_STATUS.DISABLE]: "warning",
};

export const COLOR_STICKER_STATUS: any = {
  [ENUM_BAR_DETAIL_REVIEW_STATUS.ACTIVE]: "success",
  [ENUM_BAR_DETAIL_REVIEW_STATUS.DISABLE]: "danger",
};

export const LIST_OPTION_BAR_DETAIL_REVIEW_STATUS = [
  {
    value: ENUM_BAR_DETAIL_REVIEW_STATUS.ACTIVE,
    label: "Active",
  },
  {
    value: ENUM_BAR_DETAIL_REVIEW_STATUS.DISABLE,
    label: "Disable",
  },
];

export const ENUM_BAR_DETAIL_STAFF_APPROVED_STATUS = {
  APPROVED: 1,
  WAITING: 0,
  REJECTED: 2,
};

export const COLOR_BAR_DETAIL_STAFF_APPROVED_STATUS: any = {
  [ENUM_BAR_DETAIL_STAFF_APPROVED_STATUS.APPROVED]: "success",
  [ENUM_BAR_DETAIL_STAFF_APPROVED_STATUS.WAITING]: "warning",
  [ENUM_BAR_DETAIL_STAFF_APPROVED_STATUS.REJECTED]: "danger",
};

export const LIST_OPTION_BAR_DETAIL_STAFF_APPROVED_STATUS = [
  {
    value: ENUM_BAR_DETAIL_STAFF_APPROVED_STATUS.APPROVED,
    label: "Approved",
  },
  {
    value: ENUM_BAR_DETAIL_STAFF_APPROVED_STATUS.WAITING,
    label: "Status Waiting",
  },
  {
    value: ENUM_BAR_DETAIL_STAFF_APPROVED_STATUS.REJECTED,
    label: "Rejected",
  },
];

export const LIST_OPTION_BAR_DETAIL_STAFF_LEVEL = [
  {
    label: "lv.1 Bartender",
    value: 1,
  },
  {
    label: "lv.2 Bartender",
    value: 2,
  },
  {
    label: "lv.3 Bartender",
    value: 3,
  },
  {
    label: "lv.4 Bartender",
    value: 4,
  },
  {
    label: "lv.5 Bartender",
    value: 5,
  },
];

export const ENUM_STATUS_POST = {
  ACTIVATED: 1,
  DISABLED: 0,
};

export const COLOR_STATUS_POST: any = {
  [ENUM_STATUS_POST.ACTIVATED]: "success",
  [ENUM_STATUS_POST.DISABLED]: "danger",
};

export const STATUS_POST_OPTION = [
  {
    label: "Activated",
    value: ENUM_STATUS_POST.ACTIVATED,
  },
  {
    label: "Disabled",
    value: ENUM_STATUS_POST.DISABLED,
  },
];

export const ENUM_STICKER_PACKAGE_TYPE = {
  STANDARD: 0,
  PREMIUM: 1,
};

export const COLOR_STICKER_PACKAGE_TYPE: any = {
  [ENUM_STICKER_PACKAGE_TYPE.STANDARD]: "success",
  [ENUM_STICKER_PACKAGE_TYPE.PREMIUM]: "danger",
};

export const STICKER_PACKAGE_TYPE_OPTION = [
  {
    label: "Package Type Standard",
    value: ENUM_STICKER_PACKAGE_TYPE.STANDARD,
  },
  {
    label: "Package Type Premium",
    value: ENUM_STICKER_PACKAGE_TYPE.PREMIUM,
  },
];

//reservation
export const ENUM_BOOKING_STATUS = {
  SERVING: 1,
  WAITING: 2,
  USING: 3,
  RELEASED: 4,
  DISABLED: 5,
  CANCELLED: 6,
};

export const ENUM_BOOKING_TYPE = {
  SELF_BOOKING: 1,
  STAFF_ASSISTED_BOOKING: 2,
};

export const ENUM_ARRANGE_STATUS = {
  ARRANGE: 1,
  NOT_ARRANGE: 2,
};

export const BOOKING_STATUS_OPTION = [
  {
    label: "Serving",
    value: ENUM_BOOKING_STATUS.SERVING,
  },
  {
    label: "Waiting",
    value: ENUM_BOOKING_STATUS.WAITING,
  },
  {
    label: "Using",
    value: ENUM_BOOKING_STATUS.USING,
  },
  {
    label: "Released",
    value: ENUM_BOOKING_STATUS.RELEASED,
  },
  {
    label: "Disabled",
    value: ENUM_BOOKING_STATUS.DISABLED,
  },
  {
    label: "Cancelled",
    value: ENUM_BOOKING_STATUS.CANCELLED,
  },
];

export const BOOKING_TYPE_OPTION = [
  { label: "self_booking", value: ENUM_BOOKING_TYPE.SELF_BOOKING },
  {
    label: "staff_assisted_booking",
    value: ENUM_BOOKING_TYPE.STAFF_ASSISTED_BOOKING,
  },
];

export const ARRANGE_STATUS_OPTION = [
  { label: "arrange", value: ENUM_ARRANGE_STATUS.ARRANGE },
  {
    label: "not_arrange",
    value: ENUM_ARRANGE_STATUS.NOT_ARRANGE,
  },
];

//bar detail - tables
export const ENUM_TABLE_SHARING = {
  ALLOW_SHARE: 1,
  NOT_ALLOW_SHARE: 0,
};

export const TABLE_SHARING_OPTION = [
  {
    label: "Allow Share",
    value: ENUM_TABLE_SHARING.ALLOW_SHARE,
  },
  {
    label: "Not Allow Share",
    value: ENUM_TABLE_SHARING.NOT_ALLOW_SHARE,
  },
];

export const ENUM_TABLE_TYPE = {
  VIP: 1,
  NORMAL: 2,
};

export const TABLE_TYPE_OPTION = [
  {
    label: "Vip",
    value: ENUM_TABLE_TYPE.VIP,
  },
  {
    label: "Normal",
    value: ENUM_TABLE_TYPE.NORMAL,
  },
];

//Agency
export const ENUM_AGENCY_STATUS = {
  ACTIVATED: "1",
  INACTIVATED: "0",
};

export const COLOR_AGENCY_STATUS: any = {
  [ENUM_AGENCY_STATUS.ACTIVATED]: "success",
  [ENUM_AGENCY_STATUS.INACTIVATED]: "danger",
};

export const AGENCY_STATUS_OPTION = [
  { label: "Active", value: ENUM_AGENCY_STATUS.ACTIVATED },
  { label: "InActive", value: ENUM_AGENCY_STATUS.INACTIVATED },
];

export const ENUM_AGENCY = {
  NOT_BELONG_TO_AGENCY: "0",
};

export const COLOR_AGENCY_OPTION: any = {
  [ENUM_AGENCY.NOT_BELONG_TO_AGENCY]: "danger",
};

export const LIST_AGENCY_OPTION = [
  { label: "Not belong to Agency", value: ENUM_AGENCY.NOT_BELONG_TO_AGENCY },
];

//Campaign
export const ENUM_STATUS_CAMPAIGN = {
  NOT_YET: "not_yet",
  ON_GOING: "on_going",
  END: "end",
};

export const COLOR_STATUS_CAMPAIGN: any = {
  [ENUM_STATUS_CAMPAIGN.NOT_YET]: "warning",
  [ENUM_STATUS_CAMPAIGN.ON_GOING]: "primary",
  [ENUM_STATUS_CAMPAIGN.END]: "danger",
};

export const LIST_STATUS_CAMPAIGN_OPTION = [
  {
    label: "Not yet",
    value: ENUM_STATUS_CAMPAIGN.NOT_YET,
  },
  {
    label: "On-Going",
    value: ENUM_STATUS_CAMPAIGN.ON_GOING,
  },
  {
    label: "End",
    value: ENUM_STATUS_CAMPAIGN.END,
  },
];

export const LIST_CHANNEL_OPTION = [
  {
    label: "Facebook",
    value: "facebook",
  },
  {
    label: "Google",
    value: "google",
  },
  {
    label: "Tiktok",
    value: "tiktok",
  },
  {
    label: "Offline",
    value: "offline",
  },
];

export const ENUM_AGENCY_BRANCH_STATUS = {
  LINKED: 1,
  NOT_LINK_YET: 2,
};

export const COLOR_AGENCY_BRANCH_STATUS: any = {
  [ENUM_AGENCY_BRANCH_STATUS.LINKED]: "success",
  [ENUM_AGENCY_BRANCH_STATUS.NOT_LINK_YET]: "danger",
};

export const AGENCY_BRANCH_STATUS_OPTION = [
  {
    label: "Linked",
    value: ENUM_AGENCY_BRANCH_STATUS.LINKED,
  },
  {
    label: "Not Link Yet",
    value: ENUM_AGENCY_BRANCH_STATUS.NOT_LINK_YET,
  },
];

export const AGENCY_APP_NAME_OPTION = [
  {
    label: "Baive",
    value: "baive",
  },
  {
    label: "Baive Manager",
    value: "baive_manager",
  },
];

export const ENUM_AGENCY_EVENT_ACTION_TYPE = {
  INSTALL: "install",
  OPEN: "open",
};

export const COLOR_AGENCY_EVENT_ACTION_TYPE: any = {
  [ENUM_AGENCY_EVENT_ACTION_TYPE.INSTALL]: "primary",
  [ENUM_AGENCY_EVENT_ACTION_TYPE.OPEN]: "success",
};

export const AGENCY_EVENT_ACTION_TYPE_OPTION = [
  {
    label: "Install",
    value: ENUM_AGENCY_EVENT_ACTION_TYPE.INSTALL,
  },
  {
    label: "Open",
    value: ENUM_AGENCY_EVENT_ACTION_TYPE.OPEN,
  },
];

export const PERIOD_DATE_OPTION = [
  {
    label: "No Specific Dates",
    value: "2",
  },
  {
    label: "Custom Period",
    value: "1",
  },
];

export const MANUAL_PUSH_REDIRECT_SCREEN_TARGET = [
  {
    label: "Open App",
    value: "default",
  },
  {
    label: "Feed",
    value: "hot_feed",
  },
  {
    label: "Wallpaper",
    value: "wallpaper",
  },
  {
    label: "Snap",
    value: "snap",
  },
  {
    label: "Photo News",
    value: "photo_news",
  },
  {
    label: "Promotion",
    value: "event_and_promotion",
  },
  {
    label: "Open Deep Link",
    value: "open_link",
  },
];

export const ENUM_PUSH_LOG_OPEN_STATUS = {
  OPEN: 1,
  NOTOPEN: 0,
};

export const COLOR_OPEN_STATUS: any = {
  [ENUM_PUSH_LOG_OPEN_STATUS.OPEN]: "primary",
  [ENUM_PUSH_LOG_OPEN_STATUS.NOTOPEN]: "orange-light",
};

export const PUSH_LOG_OPEN_STATUS = [
  {
    value: ENUM_PUSH_LOG_OPEN_STATUS.OPEN,
    label: "Open",
  },
  {
    value: ENUM_PUSH_LOG_OPEN_STATUS.NOTOPEN,
    label: "Not-Open",
  },
];

export const PUSH_LOG_NOTIFY_TYPE = [
  {
    value: ENUM_NOTIFY_TYPE.AUTO,
    label: "Auto",
  },
  {
    value: ENUM_NOTIFY_TYPE.MANUAL,
    label: "Manual",
  },
];

export const ENUM_PUSH_LOG_PUSH_STATUS = {
  SENT: "sent",
  FAILED: "failed",
  DEACTIVATED: "deactivated",
};

export const PUSH_LOG_PUSH_STATUS = [
  {
    value: ENUM_PUSH_LOG_PUSH_STATUS.SENT,
    label: "Push Log Sent",
  },
  {
    value: ENUM_PUSH_LOG_PUSH_STATUS.FAILED,
    label: "Push Log Failed",
  },
  {
    value: ENUM_PUSH_LOG_PUSH_STATUS.DEACTIVATED,
    label: "Push Log Deactivated",
  },
];

//Coupon issue
export const ENUM_COUPON_USE_STATUS = {
  USED: "1",
  NOT_USED: "2",
  EXPIRED: "3",
};

export const COLOR_COUPON_USE_STATUS: any = {
  [ENUM_COUPON_USE_STATUS.USED]: "success",
  [ENUM_COUPON_USE_STATUS.NOT_USED]: "warning",
  [ENUM_COUPON_USE_STATUS.EXPIRED]: "danger",
};

export const COUPON_USE_STATUS_OPTION = [
  { label: "Used", value: ENUM_COUPON_USE_STATUS.USED },
  { label: "Not-Used", value: ENUM_COUPON_USE_STATUS.NOT_USED },
  { label: "Expired", value: ENUM_COUPON_USE_STATUS.EXPIRED },
];

// Coupon Action Log

//Coupon
export const ENUM_COUPON_LOG_STATUS = {
  SUCCESS: 1,
  ERROR: 2,
};

export const COLOR_COUPON_LOG_STATUS: any = {
  [ENUM_COUPON_LOG_STATUS.SUCCESS]: "success",
  [ENUM_COUPON_LOG_STATUS.ERROR]: "danger",
};

export const COUPON_ACTION_LOG_STATUS = [
  { label: "Success", value: ENUM_COUPON_LOG_STATUS.SUCCESS },
  { label: "Error", value: ENUM_COUPON_LOG_STATUS.ERROR },
];

// Agency Prepayment
export const ENUM_STATUS_PAYMENT = {
  PAID: "paid",
  UN_PAID: "unpaid",
};

export const ENUM_STATUS_REDEEM = {
  WAITING: "waiting",
  USED: "used",
  EXPIRED: "expired",
  CANCELED: "canceled",
};

export const COLOR_STATUS_PAYMENT: any = {
  [ENUM_STATUS_PAYMENT.UN_PAID]: "danger",
  [ENUM_STATUS_PAYMENT.PAID]: "primary",
};

export const LIST_STATUS_PAYMENT_OPTION = [
  {
    label: "Paid",
    value: ENUM_STATUS_PAYMENT.PAID,
  },
  {
    label: "UnPaid",
    value: ENUM_STATUS_PAYMENT.UN_PAID,
  },
];

export const ENUM_PAYMENT_METHOD = {
  TRANSFER: "transfer",
  CASH: "cash",
};

export const COLOR_PAYMENT_METHOD: any = {
  [ENUM_PAYMENT_METHOD.CASH]: "success",
  [ENUM_PAYMENT_METHOD.TRANSFER]: "danger",
};

export const LIST_PAYMENT_METHOD_OPTION = [
  {
    label: "Transfer",
    value: ENUM_PAYMENT_METHOD.TRANSFER,
  },
  {
    label: "Cash",
    value: ENUM_PAYMENT_METHOD.CASH,
  },
];

export const LIST_REDEEM_STATUS_OPTION = [
  {
    label: "Waiting",
    value: "waiting",
  },
  {
    label: "Used",
    value: "used",
  },
  {
    label: "Expired",
    value: "expired",
  },
  {
    label: "Canceled",
    value: "canceled",
  },
];

export const LIST_REDEEM_STATUS_COLOR_OPTION: any = {
  [ENUM_STATUS_REDEEM.WAITING]: "waiting",
  [ENUM_STATUS_REDEEM.USED]: "used",
  [ENUM_STATUS_REDEEM.EXPIRED]: "expired",
  [ENUM_STATUS_REDEEM.CANCELED]: "canceled",
};

export const LIST_CHANNEL_REDEEM_OPTION = [
  {
    label: "Web Star+",
    value: "starplus_web",
  },
  {
    label: "Picaverse App",
    value: "picaverse_app",
  },
];

export const LIST_LANGUAGE_OPTION = [
  {
    label: "Japanese",
    value: "ja",
  },
  {
    label: "English",
    value: "en",
  },
];

export const ENUM_PAYMENT_TYPE = {
  REDEEMCODE: "RedeemCode",
  SELF_PURCHASE: "Self-Purchase",
};

export const COLOR_PAYMENT_TYPE: any = {
  [ENUM_PAYMENT_TYPE.SELF_PURCHASE]: "success",
  [ENUM_PAYMENT_TYPE.REDEEMCODE]: "danger",
};

export const LIST_PAYMENT_TYPE_OPTION = [
  {
    label: "RedeemCode",
    value: ENUM_PAYMENT_TYPE.REDEEMCODE,
  },
  {
    label: "Self-Purchase",
    value: ENUM_PAYMENT_TYPE.SELF_PURCHASE,
  },
];
// Status Actived Course
export const LIST_STATUS_ACTIVE_COURSE_OPTION = [
  {
    label: "Actived",
    value: ENUM_STATUS_ACTIVE_DISABLE.ACTIVATE,
  },
  {
    label: "Not-Actived",
    value: ENUM_STATUS_ACTIVE_DISABLE.DISABLED,
  },
];

// Status Code Activation
export const ENUM_STATUS_CODE = {
  ACTIVATE: "active",
  IN_ACTIVATE: "inactive",
};

export const ENUM_STATUS_COURSE = {
  ACTIVATE: "active",
  EXPIRED: "expired",
};

export const COLOR_STATUS_COURSE: any = {
  [ENUM_STATUS_COURSE.ACTIVATE]: "success",
  [ENUM_STATUS_COURSE.EXPIRED]: "danger",
};

export const COLOR_STATUS_CODE: any = {
  [ENUM_STATUS_CODE.ACTIVATE]: "success",
  [ENUM_STATUS_CODE.IN_ACTIVATE]: "danger",
};

export const LIST_STATUS_CODE_ACTIVE_OPTION = [
  {
    label: "Active",
    value: ENUM_STATUS_CODE.ACTIVATE,
  },
  {
    label: "Inactive",
    value: ENUM_STATUS_CODE.IN_ACTIVATE,
  },
];

export const LIST_STATUS_COURSE_OPTION = [
  {
    label: "Active",
    value: ENUM_STATUS_COURSE.ACTIVATE,
  },
  {
    label: "Expired",
    value: ENUM_STATUS_COURSE.EXPIRED,
  },
];

//Operator
export const LIST_OPERATOR_ROLE_OPTION = [
  {
    label: "Role_Admin",
    value: "admin",
  },
  {
    label: "Role_Agency",
    value: "agency",
  },
];

export const ENUM_STATUS_AGENCY_PREPAYMENT = {
  NOT_START: "not_start",
  ON_GOING: "on_going",
  END: "end",
};

export const COLOR_STATUS_AGENCY_PREPAYMENT: any = {
  [ENUM_STATUS_AGENCY_PREPAYMENT.NOT_START]: "warning",
  [ENUM_STATUS_AGENCY_PREPAYMENT.ON_GOING]: "primary",
  [ENUM_STATUS_AGENCY_PREPAYMENT.END]: "danger",
};

export const LIST_STATUS_AGENCY_PREPAYMENT_OPTION = [
  {
    label: "Not yet",
    value: ENUM_STATUS_AGENCY_PREPAYMENT.NOT_START,
  },
  {
    label: "On-Going",
    value: ENUM_STATUS_AGENCY_PREPAYMENT.ON_GOING,
  },
  {
    label: "End",
    value: ENUM_STATUS_AGENCY_PREPAYMENT.END,
  },
];

export const LIST_AGENCY_SNS_OPTION = [
  {
    label: "Facebook",
    value: "facebook",
  },
  {
    label: "Instagram",
    value: "instagram",
  },
  {
    label: "Tiktok",
    value: "tiktok",
  },
  {
    label: "YouTube",
    value: "youtube",
  },
];

export const LIST_CURRENCY_OPTION = [
  {
    label: "KRW",
    value: "KRW",
  },
  {
    label: "USD",
    value: "USD",
  },
];
